export default "__VITE_ASSET__CkAmJqMF__"